export enum SectionHeroLayoutDirection {
  Default = 'Default: Text on the left; Image on the right',
  Reversed = 'Reversed: Image on the left; Text on the right',
  Vertical = 'Vertical: Title above asset; centered',
  VerticalWide = 'Vertical: Title above asset; centered; Wide width',
}
